import React, { useState, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';
import '../styles/cellTooltip.css';

/**
 * Tooltip para celdas/headers de DataGrid dentro de un Modal.
 * Se renderiza vía portal a document.body con position: fixed y z-index alto,
 * de modo que no lo recorta el overflow de la celda ni lo tapa el Modal.
 * El MUI Tooltip no se muestra de forma confiable en ese contexto.
 */
export default function CellTooltip({ title, className, children }) {
    const [coords, setCoords] = useState(null);
    const ref = useRef(null);

    const show = useCallback(() => {
        if (!ref.current || title == null || title === '') {
            return;
        }
        const rect = ref.current.getBoundingClientRect();
        setCoords({ left: rect.left + rect.width / 2, top: rect.top });
    }, [title]);

    const hide = useCallback(() => setCoords(null), []);

    return (
        <>
            <span
                ref={ref}
                className={className}
                onMouseEnter={show}
                onMouseLeave={hide}
            >
                {children}
            </span>
            {coords &&
                ReactDOM.createPortal(
                    <div
                        className="cell-tooltip"
                        style={{ left: coords.left, top: coords.top }}
                    >
                        {title}
                    </div>,
                    document.body
                )}
        </>
    );
}
